/**
 * Preset visuel Karaté — tokens --cq-* injectés localement (sans modifier coquille-platform).
 */
import { emitCssVariables } from "@pws/coquille-config/browser";
import "@pws/coquille-app-shell/readable-blocks.css";
import "@pws/coquille-app-shell/connected-shell.css";
import karatePreset from "../presets/karate.json";

let injected = false;

export function injectCoquilleTokens() {
  if (injected || typeof document === "undefined") return;
  const style = document.createElement("style");
  style.setAttribute("data-coquille-bridge-tokens", "karate");
  style.textContent = emitCssVariables(karatePreset);
  document.head.appendChild(style);
  injected = true;
}

export { karatePreset };
